import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import COLORS from 'constants/colors';

export const Root = styled(FlexView)`
  height: calc(100vh - 58px);
  overflow: hidden;
`;

export const ContentWrapper = styled(FlexView)`
  flex: 1;
  overflow: hidden;
`;

export const SidebarWrapper = styled(FlexView)`
  width: 290px;
  border-right: 1px solid ${COLORS.GALLERY};
  overflow-y: auto;
`;

export const MainWrapper = styled(FlexView)`
  flex: 1;
  min-width: 0;
  padding: 24px 24px 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: ${COLORS.GREY_1};
  position: relative;
  ::-webkit-scrollbar {
    width: 6px;
  }
`;

export const SubmitBar = styled(FlexView)`
  position: sticky;
  bottom: 0;
  margin: auto -24px 0;
  padding: 16px 24px;
  background: ${COLORS.WHITE};
  border-top: 1px solid ${COLORS.BLACK_T_20};
`;

export const SubmitBarButton = styled.button`
  padding: 10px 48px;
  background: ${COLORS.YELLOW_4};
  color: ${COLORS.BLACK};
  border: 1px solid ${COLORS.BLACK};
  cursor: pointer;
  transition: opacity 0.3s ease;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const LoaderWrapper = styled(FlexView)`
  min-height: 60vh;
`;

export const NoAccessWrapper = styled(FlexView)`
  padding: 24px;
`;

export const TextButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-decoration: underline 1.5px;
  text-underline-offset: 4px;
  display: flex;
  align-items: center;
  &:hover {
    text-decoration: none;
  }
`;
